import request from '@/utils/request'
import baseUrl from '@/api/baseUrl'

export default {
	/**
	 * 媒体 列表
	 * @param {page} 第几页
	 * @return {pageSize} 每页数量
	**/
	mediaList( params={} ) {
		return request({
	    url: baseUrl + '/device/media',
	    method: 'GET',
	    params
	  })
	},

	/**
	 * 媒体 添加
	**/
	mediaAdd(data){
		return request({
			url: baseUrl + '/device/media',
			method:'POST',
			data
		})
	},

	/**
	 * 媒体 编辑
	**/
	mediaEdit(id,data){
		return request({
			url: baseUrl + '/device/media/'+id,
			method:'PUT',
			data
		})
	},
	/**
	 * 媒体 删除
	**/
	mediaDel(id){
		return request({
			url: baseUrl + '/device/media/'+id,
			method:'DELETE'
		})
	},

	/**
	 * 获取 泓益网络广播的 access_token
	**/
	getHyAccessToken() {
		return request({
	    url: baseUrl + '/device/getBroadCastToken',
	    method: 'GET'
	  })
	}
}